import { render, staticRenderFns } from "./correspondence-details.vue?vue&type=template&id=64f91a21"
import script from "./correspondence-details.vue?vue&type=script&lang=js"
export * from "./correspondence-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports